module.exports = __webpack_public_path__ + "img/1545620431.32c85ca5.jpg";